/** Hodnoty pro komponentu ComboBox. */
export enum ComboBoxValues {
    /**
     * Hodnota pro skrytou optionu, jejíž text je ale zároveň placeholderem v případě, že je v selectu vybrána možnost s prázdným textem.
     */
    placeholderOptionValue = "-1",

    /** Hodnota pro prázdnou viditelnou optionu. */
    emptyOptionValue = "-2",

    /**
     * Hodnota pro možnost reprezentující hromadnou editaci.
     */
    multiEditOptionValue = "-3",
}
